import {
  FormErrorWithDiscriminatedField,
  FormSchema,
} from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/stationEvents/types/formSchema";
import { Distributions } from "features/CenterContent/shared/operationalInformation/components/Distributions";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type StationCustomProps = {};

export const StationCustom: FC<StationCustomProps> = () => {
  const { formState } = useFormContext<FormSchema>();

  // Nested errors within discriminated types aren't great to work with in
  // react-hook-form – add error types for each layer below discriminator
  const fieldErrors: FormErrorWithDiscriminatedField<
    "severity" | "distributions"
  > = formState.errors.stationForm;

  return (
    <Distributions<FormSchema>
      contextTypesField="stationForm.distributions.contextTypes"
      fieldErrors={fieldErrors}
    />
  );
};
